'use client';

import { useReviewsClientPageController } from '@/components/reviews-client-page/use-reviews-client-page-controller';
import { ReviewsClientPageView } from '@/components/reviews-client-page/ReviewsClientPageView';

const ReviewsClientPage = () => {
    const controller = useReviewsClientPageController();

    return <ReviewsClientPageView {...controller} />;
};

export default ReviewsClientPage;
